import api from './api';

export const getMileageLogs = (params) => api.get('/mileage', { params });
export const createMileageLog = (data) => api.post('/mileage', data);
export const updateMileageLog = (logId, data) => api.patch(`/mileage/${logId}`, data);
export const deleteMileageLog = (logId) => api.delete(`/mileage/${logId}`);

export const exportMileageCSV = async ({ year, month } = {}) => {
  const res = await api.get('/mileage/export', {
    params: {
      year,
      month,
    },
    responseType: 'blob',
  });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement('a');
  a.href = url;
  const hasMonth = Number.isInteger(Number(month)) && Number(month) >= 1 && Number(month) <= 12;
  const monthSuffix = hasMonth ? `-${String(month).padStart(2, '0')}` : '';
  a.download = `mileage-${year}${monthSuffix}.csv`;
  a.click();
  URL.revokeObjectURL(url);
};
